.portals-panel {
  background: var(--kh-surface);
  border: 0.5px solid var(--kh-border);
  border-radius: var(--kh-radius-card);
  box-shadow: var(--kh-shadow-1);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.portals-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 10px;
  border-bottom: 0.5px solid var(--kh-border);
}

.manage-link {
  font-size: var(--kh-size-meta);
  color: var(--kh-red);
  font-weight: 500;
  text-decoration: none;
  transition: opacity var(--kh-duration-fast);
}

.manage-link:hover {
  opacity: 0.75;
}

.portals-list {
  display: flex;
  flex-direction: column;
  gap: 0;
  list-style: none;
  margin: 0;
  padding: 0;
}

.portal-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 6px;
  margin: 0 -6px;
  border-bottom: 0.5px solid var(--kh-border);
  border-radius: var(--kh-radius-sm);
  transition: background var(--kh-duration-fast);
}

.portal-row:last-child {
  border-bottom: none;
}

.portal-row:hover {
  background: var(--kh-surface-2);
}

.portal-status-emoji {
  font-size: 13px;
  flex-shrink: 0;
  cursor: help;
  line-height: 1;
  user-select: none;
}

.portal-name-area {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.portal-name {
  font-size: var(--kh-size-body);
  color: var(--kh-text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.portal-id-secondary {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
  white-space: nowrap;
  flex-shrink: 0;
}

.portal-name-input {
  font-size: var(--kh-size-body);
  color: var(--kh-text-primary);
  background: var(--kh-surface-2);
  border: 1px solid var(--kh-border-hover);
  border-radius: 4px;
  padding: 2px 6px;
  width: 100%;
  outline: none;
  transition: border-color var(--kh-duration-fast);
}

.portal-name-input:focus {
  border-color: var(--kh-teal);
}

.portal-rename-btn {
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: var(--kh-text-muted);
  opacity: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  transition: opacity 0.15s, color 0.15s;
}

.portal-row:hover .portal-rename-btn {
  opacity: 1;
}

.portal-rename-btn:hover {
  color: var(--kh-text-secondary);
}

.portal-status-label {
  font-size: var(--kh-size-meta);
  color: var(--kh-text-muted);
}

.connect-portal-cta {
  font-size: var(--kh-size-body);
  color: var(--kh-red);
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  width: fit-content;
  transition: opacity var(--kh-duration-fast);
}

.connect-portal-cta:hover {
  opacity: 0.75;
}
